import { render, staticRenderFns } from "./HomeRectification.vue?vue&type=template&id=85506448&scoped=true"
import script from "./HomeRectification.vue?vue&type=script&lang=js"
export * from "./HomeRectification.vue?vue&type=script&lang=js"
import style0 from "./HomeRectification.vue?vue&type=style&index=0&id=85506448&prod&lang=scss&scoped=true"
import style1 from "./HomeRectification.vue?vue&type=style&index=1&id=85506448&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85506448",
  null
  
)

export default component.exports